import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionTitleProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionTitle({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  action,
}: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
          <i className={`${icon} text-lg`}></i>
        </span>
        <div className="min-w-0">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 truncate">
            {title}
          </h2>
          {subtitle ? (
            <p className="text-xs md:text-sm text-foreground-500 truncate hidden sm:block">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {action ??
        (moreTo ? (
          <Link
            to={moreTo}
            className="text-sm text-foreground-600 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        ) : null)}
    </div>
  );
}